<template>
    <loRoot>
        <loExtend
            @sendEvent="receiveEvent"
        ></loExtend>
        <loMain>
            <loWrapper>
                <loHeader
                    :transparent="headerTransparent"
                    @sendEvent="receiveEvent"
                >
                    <!-- <mdUserFunc
                        :node="chartIcon"
                        @sendEvent="receiveEvent"
                    ></mdUserFunc> -->
                    <mdVideo></mdVideo>
                    <mdUserFile></mdUserFile>
                    <mdUserAudio></mdUserAudio>
                    <mdUserNotification
                        v-if="islogin"
                    ></mdUserNotification>
                    <mdUserLang></mdUserLang>
                    <mdUserSet></mdUserSet>
                </loHeader>
                <loContent
                    v-if="isRouterAlive"
                >
                    <transition name="animate">
                        <router-view @sendEvent="receiveEvent" />
                    </transition>
                </loContent>
                <loFooter
                    @sendEvent="receiveEvent"
                ></loFooter>
            </loWrapper>
        </loMain>
    </loRoot>
</template>

<script>
    import loRoot from '@/components/loRoot'
    import loExtend from '@/components/loExtend'
    import loContent from '@/components/loContent'
    import loMain from '@/components/loMain'
    import loWrapper from '@/components/loWrapper'
    import loHeader from '@/components/loHeader'
    import loFooter from '@/components/loFooter'
    // import mdUserFunc from '@/components/mdUserFunc'
    import mdVideo from '@/components/mdVideo'
    import mdUserFile from '@/components/mdUserFile'
    import mdUserAudio from '@/components/mdUserAudio'
    import mdUserNotification from '@/components/mdUserNotification'
    import mdUserLang from '@/components/mdUserLang'
    import mdUserSet from '@/components/mdUserSet'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            loRoot,
            loExtend,
            loContent,
            loMain,
            loWrapper,
            loHeader,
            loFooter,
            // mdUserFunc,
            mdVideo,
            mdUserFile,
            mdUserAudio,
            mdUserNotification,
            mdUserLang,
            mdUserSet,
        },
        props: {
            routerAlive: {
                type: Boolean,
                require: true
            }
        },
        data: function(){

            return {
                transitionName: 'slide-left',
                headerTransparent: false,
            }
        },
        computed: {
            ...mapState([
                'user',
                'isRouterAlive',
                'productList',
            ]),
            islogin: function(){
                return this.user.sn;
            },
            path: function(){
                return this.$route.path || ''
            },
            chartIcon: function(){
                let _path = '/system/materialPrice',
                    $chart = {
                        sn: 1,
                        icon: 'chart',
                        path: _path,
                        active: this.path === _path,
                    }

                return [
                    $chart,
                ]
            }
        },
        methods: {
            ...mapMutations([
                'changeState',
                'catchError',
                'changeProduct',
                'pushPopUp',
                'setFavorite',
            ]),
            setHeaderTransparent: function(booleam){
                this.$set(this, 'headerTransparent', !!booleam)
            },
            clickFunc: function(str){
                console.log(str);
            },
            favorite: function(opt){
                let _sn = opt.sn,
                    _favorite = !opt.favorite;

                this.setFavorite({
                    sn: _sn,
                    favorite: _favorite,
                    callback: () => {
                        opt.favorite = _favorite;
                    }
                });
            },
            contact: function(sn){

                if( sn ) {

                    let _url = this.$siteTool.apiUrl({
                            class: 'ContactSales',
                            func: 'Info',
                        }),
                        $condition = {
                            product_sn: sn,
                        }

                    this.$http.post(_url, $condition).then(res => { //弄完所有設定後開始取資料
                        res.product_sn = sn;
                    
                        this.pushPopUp({
                            type: 'showSalse',
                            content: res
                        });
                    }).catch(error => {

                        this.catchError({
                            error: error,
                            callback: () => {
                                this.contact(opt);
                            }
                        });
                    });
                }
            },
            prepage: function(){
                window.history.go(-1)
            }
        },
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in 150ms;
    }

    .animate-leave-active {
        animation: animate-out 150ms;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .lo.wrapper {
        display: flex;
        position: relative;
        flex-direction: column;
        transition: $transition;
        min-height: 100vh;

        &::before {
            @extend %mask;
            content: none;
            z-index: 7;
        }
    }

</style>
